module.exports = __webpack_public_path__ + "img/tencent-weibo.a38f2844.svg";